import React from "react";
import { Navigate } from "react-router-dom"; // Import Navigate component
import { useAuth } from "./../../contexts/authContext"; // Assuming you have a custom auth hook

function ProtectedRoute({ children }) {
	const { currentUser } = useAuth();

	if (!currentUser) {
		return <Navigate to="/login" />;
	}

	return children; // Render protected content if authenticated
}

export { ProtectedRoute };
